var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ inner: !_vm.inner }},[_vm._t("heading"),_c('div',{class:{ inner: _vm.inner }},[_c('p',{staticClass:"lead"},[_vm._t("sentence")],2),_vm._t("contents")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }